import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { FortnoxImportRun } from '../../models/FortnoxImportRun';

/** Reads one import run with its progress and failures. */
export const useGetFortnoxImportRun = () => {
  const { callAPI } = useAPI<FortnoxImportRun>({ method: 'GET' });

  const action = async (runId: string): Promise<FortnoxImportRun> =>
    (await callAPI(buildApiUrl(`fortnoxImport/${runId}`))) as FortnoxImportRun;

  return { action };
};
